import { NEW_USER_AREA, PREOWNED_USER_AREA } from 'src/constants/store/areas';
import {
    TAreas,
    DIGITAL_LEAD_TYPE,
    NEWS_LEAD_TYPE,
    PREOWNEDS_LEAD_TYPE,
} from 'src/constants/lead/leadTypes';
import { THandleGetArea } from './types';

export const handleGetArea = ({ type, carType }: THandleGetArea): TAreas => {
    if (type === DIGITAL_LEAD_TYPE) {
        if (carType === NEW_USER_AREA) return NEWS_LEAD_TYPE;
        if (carType === PREOWNED_USER_AREA) return PREOWNEDS_LEAD_TYPE;
    }
    return type;
};
